export class WatchListEndPoints {
  public static listStockWatchList = `/v1/watchlist/stock/{idUser}`;
  public static stockWatchList = `/v1/watchlist/stock`;
  public static listIndexWatchList = `/v1/watchlist/indices/{idUser}`;
  public static indexWatchList = `/v1/watchlist/indices`;
  public static updatePlayList = `/v1/watchlist/playlist`;
  public static playList = `/v1/watchlist/playlist`;
}
